function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useRef } from 'react';
import { node, string, oneOfType, shape, func, any } from 'prop-types';
var canUseDOM = typeof window !== 'undefined';
/**
 * SSR component.
 *
 * This should be removed / updated in future or merged with StaticElement as effectively this
 * is put in place to render only on server so there is no duplication of script calls upon
 * re-render.
 */

var SsrScript = function SsrScript(_ref) {
  var children = _ref.children,
      as = _ref.as,
      givenRef = _ref.ref,
      props = _objectWithoutProperties(_ref, ["children", "as", "ref"]);

  var ref = useRef(null);
  var isBrowser = SsrScript.canUseDOM; // We can't accept refs on this component as we use the created element's
  // ref to control the static content

  if (givenRef) {
    throw new Error('StaticContent does not accept refs');
  } // If we're on the server


  if (!isBrowser) {
    return /*#__PURE__*/React.createElement(as, props, children);
  } // Avoid re-render on the client


  return /*#__PURE__*/React.createElement(as, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    suppressHydrationWarning: true,
    dangerouslySetInnerHTML: {
      __html: ''
    }
  }));
};

SsrScript.defaultProps = {
  children: null,
  as: 'div',
  ref: null
};
SsrScript.propTypes = process.env.NODE_ENV !== "production" ? {
  children: node,
  as: string,
  ref: oneOfType([func, shape({
    current: any
  })])
} : {}; // Patch canUseDOM for testing

SsrScript.canUseDOM = canUseDOM;
export default SsrScript;